// extracted by mini-css-extract-plugin
export var animationAbsolute = "_18-q";
export var animationRelative = "_18-p";
export var backdropBlur = "_18-0";
export var detailLabelCell = "_18-12";
export var detailTable = "_18-11";
export var detailValueCell = "_18-13";
export var docIconBox = "_18-1d";
export var docIconBoxMd = "_18-1f";
export var docIconBoxSm = "_18-1e";
export var docTypeRow = "_18-16";
export var docTypeRowInner = "_18-17";
export var dropdownMatchDatePicker = "_18-3";
export var evidenceCardContent = "_18-1c";
export var fileUploadSpin = "_18-j";
export var gorgiasOpenButton = "_18-15 _18-d";
export var gorgiasTicketCard = "_18-14";
export var heroModalFooterButton = "_18-18";
export var hiddenContainer = "_18-o";
export var iconPrimary = "_18-1g";
export var iconQuaternary = "_18-1i";
export var iconTertiary = "_18-1h";
export var integrationCard = "_18-1";
export var integrationLogoBox = "_18-2";
export var mainColumnSticky = "_18-1b";
export var maxWidthContainer = "_18-19";
export var modalContentBody = "_18-a";
export var modalHeaderImage = "_18-5";
export var modalImageLabel = "_18-7";
export var modalImageOverlay = "_18-6";
export var modalImageSubtitle = "_18-9";
export var modalImageTitle = "_18-8";
export var modalImageWrapper = "_18-4";
export var modalStickyFooter = "_18-b";
export var removeButton = "_18-e";
export var sidebarColumn = "_18-1a";
export var spinner = "_18-i";
export var timelineLine = "_18-y";
export var timelineLineBlack = "_18-10 _18-y";
export var timelineLineGray = "_18-z _18-y";
export var timelineLineHeight = "_18-x";
export var tlDotActivate = "_18-u";
export var tlDotActivateAnim = "_18-t";
export var tlDotHide = "_18-s";
export var tlDotHideAnim = "_18-r";
export var tlLineActivate = "_18-w";
export var tlLineActivateAnim = "_18-v";
export var uploadHint = "_18-n";
export var uploadIconBox = "_18-k";
export var uploadLabel = "_18-m";
export var uploadText = "_18-l";
export var uploadZone = "_18-f";
export var uploadZoneCursorDefault = "_18-h";
export var uploadZoneCursorPointer = "_18-g";
export var uploadedFileRow = "_18-c";
export var viewButton = "_18-d";